import { RecExpandedPaymentRow } from 'components/DragNDrop/DragNDropRecExpanded';

export const DEFAULT_OFFLINE_PAYMENT_ROWS: RecExpandedPaymentRow[] = [
  {
    value: 'wire',
    label: 'Pay by Wire',
    imageUrl: '',
    enabledFieldName: 'offline_instructions_wire',
  },
  {
    value: 'check',
    label: 'Pay by Check',
    imageUrl: '',
    enabledFieldName: 'offline_instructions_check',
  },
  {
    value: 'grant',
    label: 'Pay by Grant',
    imageUrl: '',
    enabledFieldName: 'offline_instructions_grant',
  },
];
